<template>
  <UiCategoryBanner
    v-element-visibility="[onTrackingImpression, { threshold: 1 }]"
    v-bind="props"
    @category-banner-clicked="onCategoryBannerClicked"
  />
</template>

<script lang="ts" setup>
import UiCategoryBanner from '@sephora-asia/ui-category-banner'
import type { CategoryBannerContainerProps } from '~/types/components/contentful/components.types'
import { vElementVisibility } from '@vueuse/components'

const props = defineProps<CategoryBannerContainerProps>()

const { trackEvent } = useGtmTrack()

const pageMetaStore = usePageMetaStore()

function onCategoryBannerClicked(index: number) {
  const category = props.categories[index]

  trackEvent({
    event: `${pageMetaStore.pageType}_category_banner_click`,
    params: {
      banner_name: props.internalName,
      content_banner_position: props.componentPosition,
      banner_position: index + 1,
      click_name: category.title,
      page_path: useRoute().path,
      segmented: !!category?.isSegmented,
      segments: category?.segments?.join(','),
    },
  })
}

function onTrackingImpression(visibile: boolean) {
  if (visibile) {
    trackEvent({
      event: `${pageMetaStore.pageType}_category_banner_view`,
      params: {
        banner_name: props.internalName,
        content_banner_position: props.componentPosition,
        page_path: useRoute().path,
        segmented: !!props?.isSegmented,
        segments: props?.segments?.join(','),
      },
    })
  }
}
</script>

<style scoped>
.category-banner {
  padding: 24px 16px;
  background-color: var(--color-base-grey-05);
}
</style>
